<template>
  <div id="GjwTableEditCell">
    <el-input v-if="type === 'input'" v-model.trim="modifyVal" clearable @change="valChange" />
    <el-input v-else-if="type === 'textarea'" v-model.trim="modifyVal" type="textarea" :rows="1" clearable @change="valChange" />
    <el-select v-else-if="type === 'select'" v-model="modifyVal" placeholder="请选择" @change="valChange">
      <el-option
        v-for="item in config.options"
        :key="item.value"
        :label="item.label"
        :value="item.value"
      />
    </el-select>
  </div>
</template>

<script>
export default {
  name: 'GjwTableEditCell',
  props: {
    // 编辑类型：input，select, textarea
    type: {
      type: String,
      required: true
    },
    // 列的prop值
    colProp: String,
    // 默认值
    initValue: {
      type: [String, Number, Boolean]
    },
    // 配置选项，如select的options
    config: {
      type: Object,
    },
  },
  data() {
    return {
      modifyVal: this.initValue,
    }
  },
  methods: {
    valChange(val) {
      this.$emit('value-change', { colValue: val, colProp: this.colProp })
    }
  }
}
</script>

<style scoped>

</style>
